// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --height: 100vh;
  --inner-border-width: 0;
}

.ComparablesFilter {
  overflow: auto;
  height: fit-content;
}
.ComparablesFilter__Form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
.ComparablesFilter__Field {
  flex-basis: 44%;
  margin-bottom: 1rem;
}
.ComparablesFilter__Field--Max {
  margin-right: 2rem;
}
.ComparablesFilter__PropertyType {
  flex-basis: 100%;
  margin-top: 1rem;
}
.ComparablesFilter__RangeWrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-basis: 100%;
}
.ComparablesFilter__Section {
  flex-basis: 100%;
}
.ComparablesFilter__SectionLabel {
  margin-right: 0.5rem;
  font-weight: bold;
}
.ComparablesFilter__RadioGroupWrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
}
.ComparablesFilter__Button {
  margin-left: 1rem;
  font-size: 0.7rem;
}
.ComparablesFilter__RadioGroup {
  display: flex;
  flex-direction: row;
  margin: 15px 0;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ComparablesFilter__RadioGroupLabel {
  flex-basis: 100%;
  font-weight: bold;
}
.ComparablesFilter__Radio {
  max-width: 8rem;
  margin-right: 2rem;
}
.ComparablesFilter__SeparatorLine {
  height: 2px;
  border-width: 2px;
  width: 100%;
}

@media screen and (min-width: 600px) {
  .ComparablesFilter__Field--Max {
    margin-right: 3rem;
  }
  .ComparablesFilter__Button {
    font-size: 1rem;
  }
}
@media screen and (min-width: 1330px) {
  .ComparablesFilter__Field--Max {
    margin-right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-comparables/src/lib/comparables/comparables-filter/comparables-filter.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;AACJ;AAEE;EACE,eAAA;EACA,mBAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;AAMI;EACE,oBAAA;EACA,iBAAA;AAJN;AAQE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AANJ;AASE;EACE,iBAAA;EACA,iBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,8BAAA;AARJ;AAUI;EACE,gBAAA;EACA,iBAAA;AARN;AAYE;EACE,eAAA;EACA,kBAAA;AAVJ;AAaE;EACE,WAAA;EACA,iBAAA;EACA,WAAA;AAXJ;;AAeA;EAGM;IACE,kBAAA;EAdN;EAkBE;IACE,eAAA;EAhBJ;AACF;AAoBA;EAGM;IACE,kBAAA;EApBN;AACF","sourcesContent":[":host {\n  --height: 100vh;\n  --inner-border-width: 0;\n}\n\n.ComparablesFilter {\n  overflow: auto;\n  height: fit-content;\n\n  &__Form {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  &__Field {\n    flex-basis: 44%;\n    margin-bottom: 1rem;\n\n    &--Max {\n      margin-right: 2rem;\n    }\n  }\n\n  &__PropertyType {\n    flex-basis: 100%;\n    margin-top: 1rem;\n  }\n\n  &__RangeWrapper {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    flex-basis: 100%;\n  }\n\n  &__Section {\n    flex-basis: 100%;\n\n    &Label {\n      margin-right: 0.5rem;\n      font-weight: bold;\n    }\n  }\n\n  &__RadioGroupWrapper {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  &__Button {\n    margin-left: 1rem;\n    font-size: 0.7rem;\n  }\n\n  &__RadioGroup {\n    display: flex;\n    flex-direction: row;\n    margin: 15px 0;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    &Label {\n      flex-basis: 100%;\n      font-weight: bold;\n    }\n  }\n\n  &__Radio {\n    max-width: 8rem;\n    margin-right: 2rem;\n  }\n\n  &__SeparatorLine {\n    height: 2px;\n    border-width: 2px;\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 600px) {\n  .ComparablesFilter {\n    &__Field {\n      &--Max {\n        margin-right: 3rem;\n      }\n    }\n\n    &__Button {\n      font-size: 1rem;\n    }\n  }\n}\n\n@media screen and (min-width: 1330px) {\n  .ComparablesFilter {\n    &__Field {\n      &--Max {\n        margin-right: 1rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
